/** Notes module: role id with hotel-wide note visibility (admin-style). */
export const NOTES_ADMIN_ROLE_ID = 1;

export function isNotesAdmin(user) {
    if (!user) return false;
    if (user.role_id === NOTES_ADMIN_ROLE_ID) return true;
    if (user.role === NOTES_ADMIN_ROLE_ID) return true;
    if (typeof user.role === 'object' && user.role?.id === NOTES_ADMIN_ROLE_ID) return true;
    return false;
}
